import React from 'react';
import { Link } from 'gatsby';
import clsx from 'clsx';

const URL = 'https://galaxy.blob.core.windows.net/web/livia_logo.png';

const LogoWrap = ({ children }) => (
  <div className="flex items-center justify-center">{children}</div>
);

const LogoMain = ({
  url = URL,
  alt = 'A visual representation of our digital voice',
  text = 'A NOSTRA VOCE NUMERICA',
}) => (
  <LogoWrap>
    <div className="mt-32">
      <div className="liviu-logo px-3">
        <img
          loading="lazy"
          src={url}
          alt={alt}
          className="shadow-sm w-full shadow-sm aspect-[2.13] max-w-[349px]"
        />
        <p className="liviu-logo-text-big">{text}</p>
      </div>
    </div>
  </LogoWrap>
);

const Logo = ({
  url = URL,
  className = 'aspect-[1.92] max-w-[233px]',
  alt = 'A visual representation of our digital voice',
  text = 'A NOSTRA VOCE NUMERICA',
}) => (
  <LogoWrap>
    <div className="my-6">
      <div className="liviu-logo px-3">
        <Link to="/">
          <img loading="lazy" src={url} alt={alt} className={clsx('w-full', className)} />
          <p className="liviu-logo-text">{text}</p>
        </Link>
      </div>
    </div>
  </LogoWrap>
);

export { LogoMain, Logo, LogoWrap };
